<template>
  <div>
    <v-tooltip v-if="!small" top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="elevation-0"
          color="secondary"
          fab
          :loading="loading"
          :disabled="loading"
          v-bind="attrs"
          v-on="on"
          @click.stop="openDownloadApp"
          ><v-icon large>{{
            isCompleted ? 'mdi-check-circle' : 'mdi-check-circle-outline'
          }}</v-icon></v-btn
        >
      </template>
      <span>{{ toolTip }}</span>
    </v-tooltip>
    <v-btn
      v-else
      icon
      :color="isCompleted ? 'green' : 'black'"
      :loading="loading"
      :disabled="loading"
      @click.stop="openDownloadApp"
    >
      <v-icon>
        {{ isCompleted ? 'mdi-check-circle' : 'mdi-check-circle-outline' }}
      </v-icon>
    </v-btn>
    <v-dialog
      v-model="open"
      max-width="290"
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card>
        <fragment v-if="!isCompleted">
          <v-card-title class="text-h5 justify-center">
            Adventure here?
          </v-card-title>
          <v-card-text class="text-center">
            Are you sure you want to mark as completed {{ activityHeadline }}
            adventure?
          </v-card-text>
        </fragment>
        <fragment v-if="isCompleted">
          <v-card-title class="text-h5 justify-center">
            Mark as incomplete?
          </v-card-title>
          <v-card-text class="text-center">
            Are you sure? This action will remove the adventure from your saved
            items.
          </v-card-text>
        </fragment>
        <v-card-actions class="justify-center">
          <v-btn color="secondary" text @click="open = false">
            Cancel
          </v-btn>
          <v-btn color="secondary" raised @click="onClick">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

/* eslint-disable camelcase */
export default {
  name: 'MarkComplete',
  props: {
    isCompleted: { type: Boolean, default: false },
    activityId: { type: Number, required: true },
    activityHeadline: { type: String, required: true },
    small: { type: Boolean, default: false },
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    ...mapState({
      loading: (state) => state.activities.loading,
    }),
    toolTip() {
      return this.isCompleted ? 'Mark incomplete' : 'Mark Complete'
    },
  },
  methods: {
    onClick() {
      this.$emit('change', {
        activity: this.activityId,
        action: this.isCompleted ? 'uncompleted' : 'completed',
      })

      this.open = false
    },
    openDownloadApp() {
      this.$emit('change')
    },
  },
}
</script>
